import { appEntry } from "../src/entry"

export const clientRouting = true

export { render }

async function render(pageContext) {
    appEntry(pageContext)
}
